import React__default from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_CART_ESTIMATED_DELIVERY } from '../operations/queries/get-cart-estimated-delivery.js';

const useGetCartEstimatedDeliveryMessage = ()=>{
    const { dateTime: { formatDate  } , getFormattedLabel ,  } = useIntl();
    const [deliveryMessage, setDeliveryMessage] = React__default.useState('');
    const [isFailed, setIsFailed] = React__default.useState(false);
    const [loadCartEstimation, { loading  }] = useLazyQuery(GET_CART_ESTIMATED_DELIVERY, {
        onCompleted ({ cart: cartResponse  }) {
            var ref;
            if ((ref = cartResponse.failures) === null || ref === void 0 ? void 0 : ref.length) {
                cartResponse.failures.forEach((failure)=>{
                    console.error(failure.__typename);
                });
                setIsFailed(true);
            }
            if (cartResponse.validationErrors) {
                var ref1;
                (ref1 = cartResponse.validationErrors.cartErrors) === null || ref1 === void 0 ? void 0 : ref1.forEach((error)=>{
                    console.error(error.validationCode, error.defaultMessage);
                });
                setIsFailed(true);
            }
            if (cartResponse.cart) {
                const estimatedDelivery = cartResponse.cart.expectedDeliveryEstimation;
                if ((estimatedDelivery === null || estimatedDelivery === void 0 ? void 0 : estimatedDelivery.__typename) === 'DateEstimation') {
                    setDeliveryMessage(getFormattedLabel('products.deliveryIndicator.deliveryIndicationFullDate', {
                        labelData: {
                            deliveryDate: formatDate(estimatedDelivery.deliveryDate, 'short')
                        }
                    }));
                }
                if ((estimatedDelivery === null || estimatedDelivery === void 0 ? void 0 : estimatedDelivery.__typename) === 'RangeEstimation') {
                    setDeliveryMessage(getFormattedLabel('products.deliveryIndicator.shortDeliveryIndication', {
                        labelData: {
                            days: `${estimatedDelivery.deliveryRange.min}-${estimatedDelivery.deliveryRange.max}`
                        }
                    }));
                }
            }
        },
        onError (error) {
            console.error('Failed to load estimation', error.message);
            setIsFailed(true);
        }
    });
    const loadCartEstimationById = React__default.useCallback((cartId)=>{
        if (cartId) {
            loadCartEstimation({
                variables: {
                    cartId
                }
            });
        } else {
            console.error('CartId is required to load delivery estimation');
        }
    }, [
        loadCartEstimation
    ]);
    return {
        loadCartEstimationById,
        deliveryMessage,
        loading,
        isFailed
    };
};

export { useGetCartEstimatedDeliveryMessage };
//# sourceMappingURL=use-get-cart-estimated-delivery-message.js.map
